import { useCallback, useMemo } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { findIndex } from 'lodash-es'
import { useAppStore } from '@stores'
import { navigationConfig } from '../constants'

const useEditorNavigation = () => {
  const { projectId } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const disableOldPlans = useAppStore(state => state.disableOldPlans)

  const currentConfig = useMemo(() => {
    return navigationConfig
      .filter(routeConfig => !(disableOldPlans && 'isOldPlansPage' in routeConfig))
      .map(routeConfig => ({
        ...routeConfig,
        route: routeConfig.route(projectId as string),
      }))
  }, [projectId, disableOldPlans])

  const currentRouteIndex = useMemo(() => {
    return findIndex(currentConfig, ({ route }) => {
      return pathname === route
    })
  }, [currentConfig, pathname])

  const handleNext = useCallback(() => {
    // No entry when on the last page, or on a page hidden from the config (the old Pläne page).
    const route = currentRouteIndex >= 0 ? currentConfig[currentRouteIndex + 1]?.route : undefined

    if (!route) return

    navigate(route)
  }, [currentConfig, currentRouteIndex, navigate])

  const handlePrev = useCallback(() => {
    const route = currentRouteIndex > 0 ? currentConfig[currentRouteIndex - 1]?.route : undefined

    if (!route) return

    navigate(route)
  }, [currentConfig, currentRouteIndex, navigate])

  return {
    handleNext,
    handlePrev,
    currentRoute: currentConfig[currentRouteIndex],
    currentRouteIndex,
    currentConfig,
  }
}

export default useEditorNavigation
